<template>
  <content-dialog
    :visible.sync="modalVisible"
    scrollable
    max-width="500"
  >
    <!--<editor-fold desc="Dialog title">-->
    <template slot="dialogTitle">
      Switch yacht sales status
    </template>
    <!--</editor-fold>-->

    <v-card-text class="pa-6">
      <v-row

        justify="space-between"
        align="center"
        class="mb-2"
      >
        <v-col
          class="grey--text text--darken-1"
        >
          New Status
        </v-col>
        <v-col class="shrink">
          <v-chip
            :color="statusData.color"
            dark
            class="text-uppercase"
          >
            {{ statusData.label }}
          </v-chip>
        </v-col>
      </v-row>
      <p>
        You are starting official sales process for the selected yacht owner. Changing
        the yacht owner, country or yacht model is not possible afterwards.
      </p>
      <v-divider class="my-2" />
      <div>
        <v-row

          align="center"
        >
          <v-col>
            <v-subheader>
              Yacht owner
            </v-subheader>
          </v-col>
          <v-col class="shrink">
            <v-btn
              color="secondary"
              text
              @click="ownerDialogVisible = true"
            >
              <v-icon left>
                add
              </v-icon>
              Add New
            </v-btn>
          </v-col>
        </v-row>

        <v-autocomplete
          v-model="owner_id"
          outlined
          label="Select yacht owner"
          :items="owners.data"
          :loading="owners.loading"
          item-text="name"
          item-value="id"
        />
      </div>
    </v-card-text>

    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        @click="updateYacht"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Confirm Sales
      </v-btn>
    </template>

    <owner-edit-dialog
      :visible.sync="ownerDialogVisible"
      @owner:created="ownerCreated"
    />
  </content-dialog>
</template>

<script>
import Yacht from '@/models/Yacht'
import ContentDialog from '@/components/helpers/Dialog'
import OwnersApi from '@/services/api/Owners'
import OwnerEditDialog from '@/components/business/owners/OwnerEditDialog'

export default {
    name: 'SalesStatusDialog',
    components: {
      ContentDialog,
      OwnerEditDialog
    },
    props: {
      visible: Boolean,
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        statusData: Yacht.investmentStatusData[Yacht.INVESTMENT_STATUS_SALES],
        owner_id: this.yacht.owner_id,
        submitting: false,
        owners: {
          loading: false,
          data: []
        },
        ownerDialogVisible: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      yachtDirty: {
        get: function () {
          return this.yacht
        },
        set: function (value) {
          this.$emit('update:yacht', value)
        }
      }
    },
    created() {
      this.fetchOwners()
    },
    methods: {
      async fetchOwners() {
        if (!this.$can('view', 'Owner')) return

        this.owners.loading = true

        try {
          this.owners.data = await OwnersApi.getOwners()
        } catch (error) {

        } finally {
          this.owners.loading = false
        }
      },
      async updateYacht() {
        this.submitting = true

        let data = {
          investment_status: this.statusData.key,
          owner_id: this.owner_id
        }

        try {
          this.yachtDirty = await Yacht.api.save(data, this.yachtDirty.id)
          this.modalVisible = false
          this.$store.dispatch('alert', {
            'text': 'Sales started for selected yacht owner.',
            'color': 'success'
          })
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.submitting = false
        }
      },
      editOwner() {
        this.owner.editing = false
        this.owner.currentId = this.owner.newId
      },
      cancelEditOwner() {
        this.owner.editing = false
        this.owner.newId = this.owner.currentId
      },
      ownerCreated(owner) {
        this.owners.data.unshift(owner)
        this.owner_id = owner.id
      }
    }
  }
</script>

<style scoped>
</style>
